import {AutoCompleteService} from 'ionic2-auto-complete';
import { Http } from '@angular/http';
import {Injectable} from "@angular/core";
import 'rxjs/add/operator/map'
import { PbZonenData } from './pbzonen-data';
@Injectable()
export class CompleteZoneService implements AutoCompleteService {
  labelAttribute = "name";

  constructor(private pbzData:PbZonenData) {

  }
  getResults(keyword:string) {
    //console.log(keyword);
    //console.log(this.pbzData.data);

    return this.pbzData.data.filter((item) => {
      //console.log(item);
      let q = keyword.toLocaleLowerCase();
      let keywordfound = true;
      //console.log(item);
      if(item.archiviert == 1){
        return false;
      }
      if(q !== '' && item.name){        
        keywordfound = item.name.toString().toLowerCase().includes(q);
        if(!keywordfound){
          if(item.attributes && item.attributes.grundstuecknamen){
            keywordfound = item.attributes.grundstuecknamen.toString().toLowerCase().includes(q);
          }          
       }
      }
      
      return keywordfound && item.id>0;
    });


    
  }


}


// WEBPACK FOOTER //
// ./src/providers/zoneautocomplete-service.ts